import React, { FunctionComponent } from 'react';

import { PrimaryButton } from '@components/library/button/index';
import { ColorData } from '@api/v4/assets/assetTypes';

interface ColorLinkProps {
  assetData: ColorData;
}

const colorUrl = (assetData: ColorData): string => {
  const { b, c, g, hex, k, m, r, y } = assetData;

  if (hex || r || c) {
    if (hex) {
      return `http://colorhexa.com/${hex.toLowerCase()}`;
    }

    if (r) {
      return `http://colorhexa.com/color.php?c=rgb+${r}+${g}+${b}`;
    }

    if (c) {
      return `http://colorhexa.com/color.php?c=cmyk+${c}+${m}+${y}+${k}`;
    }
  }

  return undefined;
};

const ColorLink: FunctionComponent<ColorLinkProps> = ({
  assetData
}) => (
  <PrimaryButton
    icon="bff-color-hexa"
    onClick={(): void => { window.open(colorUrl(assetData), '_blank'); }}
    size="large"
  >
    {bfTranslate('View on ColorHexa')}
  </PrimaryButton>
);

export default ColorLink;
